import React from 'react';
import { icons } from 'daymap-library';

import styles from './Alert.module.scss';
import { FontIcon } from '@fluentui/react';

function Alert({iconClass, heading, type = ALERT_TYPE.Default, children}) {
    let icon;
    let cssClass;
    
    switch(type) {
        case ALERT_TYPE.Success:
            icon = icons.ICON_CSS_CLASS.Tick;
            cssClass = styles.Success;
            break;
        case ALERT_TYPE.Warning:
            icon = icons.ICON_CSS_CLASS.Alert;
            cssClass = styles.Warning;
            break;
        case ALERT_TYPE.Error:
            icon = icons.ICON_CSS_CLASS.Error;
            cssClass = styles.Error;
            break;
        default:
            icon = icons.ICON_CSS_CLASS.Info;
    }

    if (iconClass)
        icon = iconClass;

    return (
        <div className={`${styles.Alert} ${cssClass}`}>
            {icon && <div className={styles.Icon}><FontIcon iconName={icon}></FontIcon></div>}
            <div className={styles.Main}>
                {heading && <h3>{heading}</h3>}
                {children && <div className={styles.Text}>{children}</div>}
            </div>
        </div>
    )
}

export const ALERT_TYPE = {
    Default: 1,
    Success: 2,
    Warning: 3,
    Error: 4
}

export default Alert;